import React from "react";
import "./TigerSpinner.css";

export const TigerSpinner = () => {
    return (
        <div className="loader">
            <span className="loader-bg"/>
        </div>
    );
}

export const TigerSpinnerWhite = () => {
    return (
        <div className="loader">
            <span className="loader-bg-white"/>
        </div>
    );
}